export const BASE_URL = "https://api.irw-ebms-ear.co.ke";
// export const BASE_URL = "http://ebms-api.test";
// export const BASE_URL = "https://staging.irw-ebms-ear.co.ke";

export const URL = BASE_URL + "/api/web/v1/";
export const AUTH_API_URL = BASE_URL + "/auth/";
export const AZURE_SSO_REDIRECT_URL = `${AUTH_API_URL}azure/redirect`;
// export const BASE_URL = "http://ebms.localhost/IR/ebms-api/public/api/web/v1/";
export const DEFAULT_RESULT = 10000;
export const SUCCESS_RESULT = 10001;
export const FAILURE_RESULT = 10002;
export const ONGOING_RESULT = 10003;
export const REGISTRATION_SERIAL = 1;
export const LAB_SERIAL = 10;
export const PHARMACY_SERIAL = 11;
export const ADMIN_ROLE = 999;
export const MAPS_API_KEY = process.env.REACT_APP_MAPS_API_KEY || "";

export const TEMPLATES_URL = {
    "CREATE_PROJECT": "create-project",
    "CREATE_PROJECT_ENDPOINT": "create-project",
    "CREATE_TENDER": "create-tender",
    "BENEFICIARY_TEMPLATE": "beneficiary-template",
};
export const ENDPOINTS = {
    "AUTH_ME": "auth/me",
    //User Management   
    "List_Users": "users/list-users",
    "LIST_ALL_USERS": "users/list-all-users",
    "UPDATE_USER": "users/update-user",
    "LIST_ROLES": "users/list-roles",
    "AUDIT_LOGS": "users/audit-logs",
    "NOTIFICATIONS_LIST": "notifications/list",
    "NOTIFICATIONS_MAILING_LIST": "notifications/mailing-list",
    "NOTIFICATIONS_MAILING_LIST_ADD": "notifications/mailing-list/add",
    "NOTIFICATIONS_MAILING_LIST_REMOVE": "notifications/mailing-list/remove",
    "NOTIFICATIONS_RUN": "notifications/run",
    "EBMS_SETTINGS_LIST": "ebms-settings/list",
    "EBMS_SETTINGS_UPDATE": "ebms-settings/update",


    "CREATE_PROJECT": "projects/create-project",
    "PROJECT_DASHBOARD": "projects/project-dashboard",
    "PROJECT_DETAILS": "projects/project-details",
    "LIST_PROJECTS": "projects/list-projects",

    "CYCLE_DISTRIBUTIONS": "br/cycle-distributions",
    "MISSING_CYCLE_DISTRIBUTIONS": "br/missing-cycle-distributions",
    "LIST_FAILED_CRITERION": "br/list-failed-criterion",
    "LIST_BENEFICIARIES_WITH_SRF": "br/list-beneficiaries-with-srf",
    "LIST_ACTIVE_BENEFICIARIES_DETAILS": "br/list-active-beneficiaries-details",
    "DISTRIBUTIONS_SUMMARY": "br/distributions-summary",
    "COMPONENT_SELECTION_CRITERIA_TEMPLATE": "projects/component-selection-criteria-template",
    "MEAL_VERIFICATION": "br/meal-verification",
    "UPDATE_BENEFICIARY_LOCATIONS": "br/update-beneficiary-locations",
    "UPDATE_BENEFICIARY_SRF": "br/update-beneficiary-srf",
    "TEMPLATE_DETAILS": "templates/get-template",
    "LOCATION_TEMPLATE": "templates/get-location-template",
    "EXPORT_DATA": "export/beneficiaries-per-cycle",
    "MASTERLIST_STATUS": "export/masterlist-status",
    "MASTERLIST_CANCEL": "export/masterlist-cancel",
    "POST_WEB_SURVEY_RESPONSES": "post-web-survey-responses",
    "LOAD_WEB_SURVEY_DETAILS": "web-survey-details",
    "SURVEY_DETAILS": "surveys/survey-details",
    "LEAVE_DASHBOARD": "hrm/dashboard/leave",
    "LOAD_COUNTRY_DASHBOARD": "dashboards/country-dashboard",
    "ID_DETAILS": "card/staff-details",
    "ACTIVE_SURVEYS": "surveys/active-surveys",
    "UPDATE_BENEFICIARY": "br/update-beneficiary",
    "UPDATE_BENEFICIARY_BASIC_DETAILS": "br/update-basic-details",
    "UPDATE_BENEFICIARY_COMPONENT": "br/update-bnf-component",
    "DELETE_COMPONENT": "projects/delete-component",
    "DELETE_COMPONENT_CYCLE": "projects/delete-component-cycle",
    "DEACTIVATE_BENEFICIARY": "br/deactivate-beneficiary",
    "ASSIGNED_RIGHTS": "rights/list-assigned-permission",
    "ALL_RIGHTS": "rights/list-permissions-to-assign",
    "ALL_RIGHTS_USERS": "rights/list-users",
    "ASSIGN_RIGHTS_USERS": "rights/assign-permission",
    "LOAD_PERMISSIONS": "rights/list-permissions",
    "NEW_PERMISSION_TEMPLATE": "rights/create-permission-template",
    "CREATE_PERMISSIONS": "rights/create-permission",
    "UPDATE_PERMISSIONS": "rights/update-permission",
    "GET_PERMISSION": "rights/get-permission",
    "AMEND_TEMPLATE": "templates/edit-template",
    "PROJECT_CYCLES": "projects/list-component-cycles",
    "LIST_PAYROLLS": "hrm/payroll/list-payrolls",
    "LIST_PAYROLL_SETUP": "hrm/payroll/list-payrolls-setup",
    "INITIALIZE_PAYROLL": "hrm/payroll/initialize-payroll",
    "SAVE_PAYROLL": "hrm/payroll/save-payroll",
    "UNDO_PAYROLL": "hrm/payroll/undo-payroll-save",
    "PROCESS_PAYROLL": "hrm/payroll/process",
    "PAYROLL_DETAILS": "hrm/payroll/payroll-details",
    "CREATE_STAFF_BANK_ACCOUNT": "hrm/bank-accounts/create",
    "LIST_PAYROLL_TRACKS": "hrm/payroll/track/list",
    "LIST_COMPLETED_TRACKS": "hrm/payroll/track/list-complete",
    "CREATE_PAYROLL_TRACK": "hrm/payroll/track/create",
    "LIST_COMPLETE_PAYROLL_TRACK": "hrm/payroll/track/list-complete",

    "LIST_TRACK_PAYROLL_DETAILS": "hrm/payroll/track/track-details",
     "TRACK_PAYROLL_APPROVAL_DETAILS": "hrm/payroll/track/track-approval-details",
     "TRACK_PAYROLL_APPROVAL": "hrm/payroll/track/action",
     "UPDATE_PAYROLL_TRACK_DETAILS": "hrm/payroll/track/update-payroll-details",

    "LIST_DEDUCTIONS": "hrm/payroll/adjustments/deductions/list",
    "LIST_EARNINGS": "hrm/payroll/adjustments/earning/list",


    "LIST_DAILY_ATTENDANCE": "hrm/staff-attendance/daily-attendance",
    "DAILY_ATTENDANCE_REPORT": "hrm/staff-attendance/daily-attendance-report",
    "STAFF_ATTENDANCE_SUMMARY": "hrm/staff-attendance/attendance-summary",
    "STAFF_ATTENDANCE_DETAILS": "hrm/staff-attendance/attendance-details",
    "STAFF_ID_CARDS": "hrm/staff-id-cards",
    "STAFF_ID_CARDS_RESET_LINKS": "hrm/staff-id-cards/reset-links",
    "LIST_INATTENDANCE_TYPES": "hrm/staff-attendance/list-inattendance-types",
    "CREATE_INATTENDANCE_TYPES": "hrm/staff-attendance/create-staff-inattendance",


    "BNF_ATTENDANCE": "projects/bnf-attendance/auto-attend",
    "LIST_CLOCKINS": "projects/bnf-attendance/list-clockins",
    "DELETE_CLOCKIN": "projects/bnf-attendance/delete-clockin",
    "SEARCH_CARD_HISTORY": "br/card-history",
    "GET_BENEFICIARY_BY_TELEPHONE": "br/get-beneficiary-by-telephone",








    "GET_PAYSLIP": "hrm/payroll/payslip",
    "SAVE_SALARY_ADVANCE": "hrm/payroll/save-salary-advance",
    "SALARY_ADVANCE_ACTION": "hrm/payroll/salary-advance-action",
    "LIST_ALLOWANCES": "hrm/payroll/list-allowances",
    "ASSIGN_ALLOWANCES": "hrm/payroll/assign-allowances",
    "DELETE_ALLOWANCE_ASSIGNMENTS": "hrm/payroll/delete-allowance-assignments",
    "ASSIGN_TAX": "hrm/payroll/assign-taxes",
    "DELETE_TAX_ASSIGNMENTS": "hrm/payroll/delete-tax-assignments",
    "ASSIGN_TAGS": "hrm/payroll/assign-tags",


    "LIST_TAXES": "hrm/payroll/list-taxes",
    "LIST_PENDING_ADVANCES": "hrm/payroll/list-pending-advances",
    "LEAVE_TYPES": "hrm/leave/list-leave-types",
    "CREATE_LEAVE": "hrm/leave/create",
    "LEAVE_DETAILS": "hrm/leave/leave-details",
    "CONTRACT_TRACKSHEET": "hrm/contract-tracksheet",
    "STAFF_CONTRACTS_CREATE": "hrm/staff-contracts/create",
    "STAFF_CONTRACTS_UPDATE": "hrm/staff-contracts/update",
    "STAFF_CONTRACTS_CONTRACT_TYPES": "hrm/staff-contracts/contract-types",
    "STAFF_CONTRACTS_DEACTIVATE": "hrm/staff-contracts/deactivate",
    "LIST_LEAVE_REQUESTS": "hrm/leave/list-leave-requests",
    "MY_LEAVE_REQUESTS": "hrm/leave/my-leave-requests",
    "CANCEL_LEAVE_REQUEST": "hrm/leave/cancel",
    "LEAVE_PENDING_ACTIONS": "hrm/leave/my-leave-pending-actions",

    "TOIL_PENDING_ACTIONS": "hrm/leave/toil/pending-requests",
    "TOIL_PENDING_CLAIMS": "hrm/leave/toil/pending-claims",
    "MY_TOIL_REQUESTS": "hrm/leave/toil/my-list",
    "CLAIM_TOIL_REQUEST": "hrm/leave/toil/claim-request",
    "TOIL_DETAILS": "hrm/leave/toil/details",




    "APPROVE_LEAVE": "hrm/leave/action",
    "UPDATE_LEAVE_APPROVER": "hrm/leave/update-leave-approver",
    "APPROVE_TOIL": "hrm/leave/toil/action",



    "CREATE_TOIL": "hrm/leave/toil/create",








    "BENEFICIARY_DETAILS": "br/beneficiary-details",
    "UPDATE_BENEFICIARY": "br/update-beneficiary",

    "GET_PROJECT_CODES": "hrm/ba/projects",
    "CREATE_ALLOCATIONS": "hrm/ba/create-allocations",
    "CREATE_BUDGET_CODES": "hrm/ba/create-project-codes",
    "STAFF_ALLOCATIONS": "hrm/ba/staff-allocations",
    "LIST_MONTHLY_ALLOCATIONS": "hrm/ba/list-monthly-allocations",
    "DELETE_ALLOCATION": "hrm/ba/delete-allocation",
    "CREATE_MONTHLY_ALLOCATIONS": "hrm/ba/create-monthly-allocations",
    "LIST_MONTHLY_ALLOCATIONS_PER_STAFF": "hrm/ba/list-monthly-allocations",
    "DELETE_MONTHLY_ALLOCATION": "hrm/ba/delete-monthly-allocation",
    "ALL_MONTHLY_ALLOCATIONS": "hrm/ba/all-monthly-allocations",

    "LIST_STAFF_DETAILS": "hrm/list-staff-details",
    "LIST_TAGS": "hrm/payroll/tags",
    "LIST_WORKFLOWS": "workflows/list",
    "LIST_WORKFLOW_LEVELS": "workflows/levels/list",
    "CREATE_WORKFLOW_LEVEL": "workflows/levels/create",
    "UPDATE_WORKFLOW_LEVEL": "workflows/levels/update",


    "LIST_WORKFLOW_LEVEL_ASSIGNMENTS": "workflows/levels/assignments/list",
    "CREATE_WORKFLOW_LEVEL_ASSIGNMENT": "workflows/levels/assignments/create",
    "UPDATE_WORKFLOW_LEVEL_ASSIGNMENT_ACTIONS": "workflows/levels/assignments/update",
    "LIST_WORKFLOW_LEVEL_ASSIGNMENT_ACTIONS": "workflows/levels/assignments/actions/list",
    "CREATE_WORKFLOW_ASSIGNMENT_ACTIONS": "workflows/levels/assignments/actions/create",
    "UPDATE_WORKFLOW_ASSIGNMENT_ACTIONS": "workflows/levels/assignments/actions/update",
    "LIST_USERS": "rights/list-users",
    "LIST_ACTIVE_USERS": "users/list-users",
    "ACTIVE_CLAIMS": "hrm/leave/toil/active-claims",
    "GET_PRESCRIPTION_TEMPLATE": "hmis/get-prescription-template",
    "LIST_PRESCRIPTION": "hmis/list-prescriptions",

    "ADD_PRESCRIPTION": "hmis/create-prescription",
    "DELETE_PRESCRIPTION": "hmis/delete-prescription",

    "GET_PRESCRIPTION_VOUCHER": "hmis/search-voucher",
    "VERIFY_VOUCHER": "hmis/verify-voucher",
    "REQUEST_VOUCHER_VERIFICATION": "hmis/request-voucher-verification",
    "GET_ACTIVE_CYCLES": "hmis/list-active-cycles",
    "REDEEM_PRESCRIPTION": "hmis/redeem-prescription",
    "REDEEMPTIONS_PER_CENTER":"hmis/reports/redemptions-per-center",
    "LIST_CENTERS":"projects/centers/list",

    "REDEMPTIONS_PER_CYCLE": "hmis/reports/redemptions-per-cycle",
    "PATIENT_HISTORY": "hmis/patient-history",
    "LAB_RESULT_TEMPLATE": "hmis/get-lab-template",

    "LIST_PERMISSIONS_TO_ASSIGN": "rights/list-permissions-to-assign",
    "UPDATE_ACCESS_PERMISSION": "rights/update-access-permission",
    "CLONE_BENEFICIARIES":"projects/clone-beneficiaries",
    "LIST_EMPLOYEES": "hrm/ba/list-employees",
    "LIST_BUDGET_CODES": "hrm/payroll/reports/budget-codes",
    "WORKFORCE_PLANNING_CREATE": "hrm/workforce-planning/create",
    "WORKFORCE_PLANNING_LIST": "hrm/workforce-planning/list",
    "WORKFORCE_PLANNING_DETAILS": "hrm/workforce-planning/details",
    "WORKFORCE_PLANNING_UPDATE": "hrm/workforce-planning/update",
    "WORKFORCE_PLANNING_UPDATE_STATUS": "hrm/workforce-planning/update-status",
    "WORKFORCE_PLANNING_DELETE": "hrm/workforce-planning/delete",
    "WORKFORCE_PLANNING_REPORT": "hrm/workforce-planning/report",
    "WORKFORCE_PLANNING_UPDATE_COMMITTEE_DECISION": "hrm/workforce-planning/update-committee-decision",
    "WORKFORCE_PLANNING_CD_ACTION": "hrm/workforce-planning/cd-action",
    "WORKFORCE_PLANNING_REVIEWS_CREATE": "hrm/workforce-planning/reviews/create",
    "WORKFORCE_PLANNING_REVIEWS_UPDATE": "hrm/workforce-planning/reviews/update",
    "LIST_OFFICES": "offices/list-offices",
    "LIST_STAFF_DESIGNATIONS": "hrm/staff-designations/list",
    "BULK_UPDATE_STAFF_DESIGNATION_DEPARTMENT": "hrm/staff-designations/bulk-update-department",
    "WASH_PROJECTS_CREATE": "wash/projects/create",
    "WASH_PROJECTS_LIST": "wash/projects/list",
    "WASH_PROJECTS_DETAILS": "wash/projects/details",
    "WASH_PROJECTS_UPDATE": "wash/projects/update",
    "WASH_PROJECTS_DELETE": "wash/projects/delete",
};
export const LOCAL_PATHS = {
   "List_Users":"/users/list",
"LIST_PROJECTS": "/projects/list", 
"PAYROLL_SELECTION": "/hrm/payroll-selection", 
"PAYROLL_DETAILS":"/hrm/payroll-details",
 
"PAYSLIP":"/hrm/payslip",
"EMPLOYEE_PROFILE":"/hrm/employee-profile",
"LEAVE_PENDING_ACTIONS":"/hrm/leave/approve-leave"
};
export const LOCAL_PARAMS = {
    "VIEWED_PROJECT": "DFSQWrf658TFEQ6HJ7",
};